import { Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from './config';
import PrivateRoute from './guards/PrivateRoute';
import PublicRoute from './guards/PublicRoute';

// Layout
import MainLayout from '@/layout/MainLayout';

// Containers
import Login from '@/containers/Login';
import Dashboard from '@/containers/Dashboard';
import Portals from '@/containers/Portals';
import PortalDetails from '@/containers/PortalDetails';
import CreatePortal from '@/containers/Portals/CreatePortal';
import CreatePortalChooser from '@/containers/Portals/CreatePortalChooser';
import CopyPortalWizard from '@/containers/Portals/portalCopy/CopyPortalWizard';
import SsoProviderPage from '@/containers/PortalDetails/SsoProviderPage';
import AuthCallback from '@/containers/AuthCallback';
import ChangePassword from '@/containers/ChangePassword';
import ForgotPassword from '@/containers/ForgotPassword';
import ResetPassword from '@/containers/ResetPassword';
import Users from '@/containers/Users';
import SystemSettings from '@/containers/SystemSettings';

export const AppRoutes = () => {
  return (
    <Routes>
      {/* Root redirect */}
      <Route path={ROUTES.ROOT} element={<Navigate to={ROUTES.DASHBOARD_HOME} replace />} />

      {/* Public routes */}
      <Route
        path={ROUTES.LOGIN}
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path={ROUTES.REGISTER}
        element={
          <PublicRoute>
            <Login /> {/* TODO: Create Register component */}
          </PublicRoute>
        }
      />

      {/* SSO OAuth callback (no guard — handles its own auth flow) */}
      <Route path={ROUTES.AUTH_CALLBACK} element={<AuthCallback />} />

      {/* Forgot / Reset password (public, no auth needed) */}
      <Route
        path={ROUTES.FORGOT_PASSWORD}
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />
      <Route
        path={ROUTES.RESET_PASSWORD}
        element={<ResetPassword />}
      />

      {/* Change password (private, full-screen, no layout) */}
      <Route
        path={ROUTES.CHANGE_PASSWORD}
        element={
          <PrivateRoute>
            <ChangePassword />
          </PrivateRoute>
        }
      />

      {/* Private routes under MainLayout */}
      <Route
        path={ROUTES.DASHBOARD}
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        {/* Default dashboard redirect */}
        <Route index element={<Navigate to="home" replace />} />

        {/* Dashboard Home */}
        <Route path="home" element={<Dashboard />} />

        {/* Portals */}
        <Route path="portals" element={<Portals />} />
        <Route path="portals/create" element={<CreatePortalChooser />} />
        <Route path="portals/create/scratch" element={<CreatePortal />} />
        <Route path="portals/create/copy" element={<CopyPortalWizard />} />
        <Route path="portals/:portalId" element={<PortalDetails />} />
        <Route path="portals/:portalId/sso/add" element={<SsoProviderPage />} />
        <Route path="portals/:portalId/sso/:providerId/edit" element={<SsoProviderPage />} />

        {/* Users */}
        <Route path="users" element={<Users />} />

        {/* System Settings */}
        <Route path="settings" element={<SystemSettings />} />
      </Route>

      {/* Catch all - redirect to root */}
      <Route path="*" element={<Navigate to={ROUTES.ROOT} replace />} />
    </Routes>
  );
};

export default AppRoutes;
